import type { Material } from '@babylonjs/core/Materials/material';
import { Scene } from '@babylonjs/core/scene';
import type { FogScale } from '../config/rendering.config';

/**
 * Own linear fog band for one material (landmarks such as the ad gantry over the road stay visible
 * further than the track around them). Babylon binds the scene fog for every draw and then notifies
 * onBind – the override scales the current (day/night blended) fog distances for this material only.
 * Any other material drawn next sees a different cached material and binds the scene fog again.
 */
export function stretchFog(material: Material, scale: FogScale): void {
  const scene = material.getScene();
  material.onBindObservable.add((mesh) => {
    const effect = mesh.subMeshes?.[0]?.effect;
    if (!effect || !scene.fogEnabled || !mesh.applyFog || scene.fogMode !== Scene.FOGMODE_LINEAR) return;
    effect.setFloat4('vFogInfos', scene.fogMode, scene.fogStart * scale.start, scene.fogEnd * scale.end, scene.fogDensity);
  });
}
